<template>
    <vx-card title="Advertisments">
        <div id="viewAdvertismentLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true"
                @search="handleSearch"
                @change-page="handleChangePage"
                @sort="handleSort"
                v-model="selected"
                :data="advertisments">

                <template slot="header">
                    <div class="flex flex-wrap items-center w-full mb-2">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addAdvertisment">Add a Advertisment</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th >Url</vs-th>
                    <vs-th >Show time in seconds</vs-th>
                    <vs-th >Status</vs-th>
                    <vs-th >Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].redirect_url">
                            <feather-icon v-if="data[indextr].url" class="cursor-pointer" @click="redirectToAppPath(data[indextr].url)" icon="Share2Icon" svgClasses="w-10 h-10 text-primary"></feather-icon>
                        </vs-td>
                        <vs-td :data="data[indextr].seconds">
                            {{data[indextr].seconds}}
                        </vs-td>
                        <vs-td :data="data[indextr].status">
                            <vs-chip  color="primary" class="product-order-status">
                                {{data[indextr].status}}
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-row>
                                <vs-button @click="editAdvertisment(data[indextr])" class="mr-2" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deleteAdvertisment(data[indextr])" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup  classContent="popup-example h-full" title="Add Advertisment" :active.sync="activePromptAddAdvertisment">
                <div id="createAdvertismentLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="addAdvertismentForm">
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'url'" placeholder="Redirect url" name="url" v-model="create_url" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addAdvertismentForm.url')">{{ errors.first('addAdvertismentForm.url') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'integer'" placeholder="Show time in seconds" name="seconds" v-model="create_second" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addAdvertismentForm.seconds')">{{ errors.first('addAdvertismentForm.seconds') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-switch style="width: 100px;" color="primary" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="create_status">
                                    <span slot="on">Active</span>
                                    <span slot="off">Inactive</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="createAdvertisment()" color="primary" type="filled">Save Advertisment</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <vs-popup  classContent="popup-example h-full" title="Edit Advertisment" :active.sync="activePromptEditAdvertisment">
                <div id="editAdvertismentLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="editAdvertismentForm">
                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'url'" placeholder="Redirect url" name="redirect_url" v-model="update_url" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('editAdvertismentForm.redirect_url')">{{ errors.first('editAdvertismentForm.redirect_url') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'integer'" placeholder="Show time in seconds" name="seconds" v-model="update_second" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addAdvertismentForm.seconds')">{{ errors.first('addAdvertismentForm.seconds') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-switch style="width: 100px;" color="primary" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="update_status">
                                    <span slot="on">Active</span>
                                    <span slot="off">Inactive</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="updateAdvertisment()" color="primary" type="filled">Update Advertisment</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <div class="vx-row mt-base">
                <div class="vx-col w-full mb-2">
                    <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'

export default {
    components: {
        vSelect,
        Treeselect,
    },
    data() {
        return {
            selected:[],
            key : null, 
            active : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            advertisments: [],
            deleteAdvertismentData : null,

            activePromptAddAdvertisment : false,
            activePromptEditAdvertisment : false,

            create_url : null,
            create_second : null,
            create_status : true,

            update_id : null,
            update_url : null,
            update_second : null,
            update_status : true,
        }
    },
    watch: {
        currentPage(val) {
            this.searchAdvertisments()
        }
    },
    async mounted() {
        await this.viewAdvertisments() 
        this.advertisments = this.$store.state.questionManagement.advertisments
    },
    methods: {
        redirectToAppPath(path){
            window.open(path, "_blank");
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
            // queued file, not yet uploaded. Just remove from the arrays
              this.fileRecordsForUpload.splice(i, 1);
              var k = this.image.indexOf(fileRecord);
              if (k !== -1) this.image.splice(k, 1);
            } else {
              this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        addAdvertisment() {
            this.create_redirect_url = null;
            this.activePromptAddAdvertisment = true;
        },
        createAdvertisment(){
            this.$validator.validateAll('addAdvertismentForm').then(result => {
                if (result) this.createAdvertismentApi()
            })
        },
        createAdvertismentApi(){
            var self = this 
            this.$vs.loading({
              container: '#createAdvertismentLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('url', this.create_url);
            data.append('seconds', this.create_second);
            data.append('status', this.create_status ? 'active' : 'inactive');

            this.$store.dispatch("questionManagement/createAdvertisment", data)
                .then(res => { 
                    this.$vs.loading.close('#createAdvertismentLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Advertisment created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.activePromptAddAdvertisment = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#createAdvertismentLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "addAdvertismentForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        editAdvertisment(advertisment) {
            this.update_id = advertisment.id;
            this.update_url = advertisment.url;
            this.update_second = advertisment.seconds;
            this.update_status = advertisment.status == "active" ? true : false;
            this.activePromptEditAdvertisment = true
        },
        updateAdvertisment(){
            this.$validator.validateAll('editAdvertismentForm').then(result => {
                if (result) this.updateAdvertismentApi()
            })
        },
        updateAdvertismentApi(){
            var self = this 
            this.$vs.loading({
              container: '#editAdvertismentLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('id', this.update_id);
            data.append('url', this.update_url);
            data.append('seconds', this.update_second);
            data.append('status', this.update_status ? 'active' : 'inactive');

            this.$store.dispatch("questionManagement/updateAdvertisment", data)
                .then(res => { 
                    this.$vs.loading.close('#editAdvertismentLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Advertisment updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.update_id = null;
                    this.activePromptEditAdvertisment = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#editAdvertismentLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "editAdvertismentForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteAdvertisment(place) {
            this.deleteAdvertismentData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this data ?',
                accept: this.acceptDeleteAdvertisment
            })
        },
        acceptDeleteAdvertisment() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteAdvertisment", { id : this.deleteAdvertismentData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Advertisment deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        
        
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchAdvertisments()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchAdvertisments()
            }
        },
        async searchAdvertisments() {
            var self = this
            this.$vs.loading({
                container: '#viewAdvertismentLoadingDiv',
                scale: 0.6
            })

            let data = { 
                name : this.selected_place_name, 
                location : this.selected_place_location, 
                sort : this.key, 
                sort_key : this.active, 
                page : this.currentPage,
                place_type : this.selected_place_type,
            }

            await this.$store.dispatch("questionManagement/viewAdvertisment", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewAdvertismentLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewAdvertismentLoadingDiv > .con-vs-loading')
                })

                this.advertisments = this.$store.state.questionManagement.advertisments
        },
        async viewAdvertisments() {
            var self = this

            await this.$store.dispatch("questionManagement/viewAdvertisment", {page : this.currentPage})
                .then(res => { 
                    this.totalPage = res.data.last_page
                })

            this.advertisments = this.$store.state.questionManagement.advertisments
        },
    },
    async created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        
    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.vs-con-textarea{
    height: 400px;
}

.vs-textarea {
    height: 100%;
}

</style>

